(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["scroll"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('scroll-timeline-section')) {
    class ScrollTimelineSection extends HTMLElement {
      connectedCallback() {
        this.items = Array.from(this.querySelectorAll('.scroll-timeline__item'));
        this.progressBar = this.querySelector('[data-timeline-progress]');
        this.line = this.querySelector('.scroll-timeline__line');

        if (!this.items.length || !this.progressBar || !this.line) return;

        if (!window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
          this.classList.add('scroll-timeline--ready');
        }

        this.observer = new IntersectionObserver(this.onIntersect.bind(this), {
          rootMargin: '0px 0px -40% 0px',
          threshold: 0
        });
        this.items.forEach((item) => this.observer.observe(item));
      }

      onIntersect(entries) {
        entries.forEach((entry) => {
          const passed = entry.isIntersecting || entry.boundingClientRect.top < 0;
          entry.target.classList.toggle('is-active', passed);
        });
        this.updateProgress();
      }

      updateProgress() {
        const active = this.items.filter((item) => item.classList.contains('is-active'));
        let height = 0;

        if (active.length) {
          const dot = active[active.length - 1].querySelector('.scroll-timeline__dot');
          if (dot) {
            const lineRect = this.line.getBoundingClientRect();
            const dotRect = dot.getBoundingClientRect();
            height = dotRect.top - lineRect.top + dotRect.height / 2;
          }
        }

        this.progressBar.style.height = Math.max(0, Math.round(height)) + 'px';
      }

      disconnectedCallback() {
        if (this.observer) this.observer.disconnect();
      }
    }

    customElements.define('scroll-timeline-section', ScrollTimelineSection);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["store-locator"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('store-locator-map')) {
    class StoreLocatorMap extends HTMLElement {
      connectedCallback() {
        this.map = this.querySelector('.store-locator__map');
        this.tooltip = this.querySelector('[data-tooltip]');
        this.pins = Array.from(this.querySelectorAll('.store-locator__pin'));
        if (!this.map || !this.tooltip || !this.pins.length) return;

        this.pins.forEach((pin) => {
          pin.addEventListener('pointerenter', () => this.show(pin));
          pin.addEventListener('pointerleave', () => this.scheduleHide(600));
          pin.addEventListener('focus', () => this.show(pin));
          pin.addEventListener('blur', () => this.scheduleHide(200));
          pin.addEventListener('click', () => this.show(pin));
        });

        this.tooltip.addEventListener('pointerenter', () => clearTimeout(this.hideTimer));
        this.tooltip.addEventListener('pointerleave', () => this.scheduleHide(300));
        this.addEventListener('keydown', (event) => {
          if (event.key === 'Escape') this.hide();
        });
      }

      show(pin) {
        clearTimeout(this.hideTimer);
        this.tooltip.innerHTML = pin.dataset.tooltipContent;
        const mapRect = this.map.getBoundingClientRect();
        const pinRect = pin.getBoundingClientRect();
        this.tooltip.style.top = pinRect.bottom - mapRect.top + 8 + 'px';

        if (pin.dataset.direction === 'left') {
          this.tooltip.style.left = 'auto';
          this.tooltip.style.right = mapRect.right - pinRect.right + 'px';
        } else {
          this.tooltip.style.right = 'auto';
          this.tooltip.style.left = pinRect.left - mapRect.left + 'px';
        }

        this.tooltip.classList.add('is-visible');
      }

      scheduleHide(delay) {
        clearTimeout(this.hideTimer);
        this.hideTimer = setTimeout(() => this.hide(), delay);
      }

      hide() {
        this.tooltip.classList.remove('is-visible');
      }

      disconnectedCallback() {
        clearTimeout(this.hideTimer);
      }
    }

    customElements.define('store-locator-map', StoreLocatorMap);
  }

  } catch(e) { console.error(e); }
})();
})();
